export enum BoschUiIconNames {
  Add = 'add',
  Agility = 'agility',
  AlertError = 'alert-error',
  AlertInfo = 'alert-info',
  AlertWarning = 'alert-warning',
  AlertWarningFilled = 'alert-warning-filled',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowUp = 'arrow-up',
  BackLeft = 'back-left',
  Batch = 'batch',
  Box = 'box',
  BoxDelivery = 'box-delivery',
  BoxDeliveryConnected = 'box-delivery-connected',
  BoxDeliveryCheckmark = 'box-delivery-checkmark',
  BoxQuestionmark = 'box-questionmark',
  Calendar = 'calendar',
  CalendarClock = 'calendar-clock',
  Chat = 'chat',
  Checkmark = 'checkmark',
  CircleSegment = 'circle-segment',
  Clipboard = 'clipboard',
  ClipboardCheckmark = 'clipboard-checkmark',
  Clock = 'clock',
  Close = 'close',
  CloseSmall = 'close-small',
  Components = 'components',
  ComponentsReservation = 'components-reservation',
  CubeFilled = 'cube-filled',
  Delete = 'delete',
  Delivery = 'delivery',
  DeliveryCheckmark = 'delivery-checkmark',
  Document = 'document',
  DocumentAdd = 'document-add',
  DocumentCheck = 'document-check',
  DocumentSettings = 'document-settings',
  DocumentXls = 'document-xls',
  Down = 'down',
  DownloadFrame = 'download-frame',
  Download = 'download',
  Edit = 'edit',
  EmergencyExit = 'emergency-exit',
  Exit = 'exit',
  Export = 'export',
  ForwardRightSmall = 'forward-right-small',
  Filter = 'filter',
  Fullscreen = 'fullscreen',
  FullscreenExit = 'fullscreen-exit',
  Globe = 'globe',
  GlobeLanguage = 'globe-language',
  GlobeSearch = 'globe-search',
  HandoverCheck = 'handover-check',
  History = 'history',
  Locator = 'locator',
  LocatorTracking = 'locator-tracking',
  Map = 'map',
  MaterialList = 'material-list',
  Message = 'message',
  NotificationAdd = 'notification-add',
  NotificationAddFilled = 'notification-add-filled',
  Paperplane = 'paperplane',
  PlaneSide = 'plane-side',
  PlaneStart = 'plane-start',
  PlaneLand = 'plane-land',
  PlaneTop = 'plane-top',
  ListView = 'list-view',
  Save = 'save',
  Search = 'search',
  SearchNumber = 'search-number',
  Ship = 'ship',
  ShipSide = 'ship-side',
  ShipDelivery = 'ship-delivery',
  ShipPort = 'ship-port',
  SpeedometerSpeedHigh = 'speedometer-speed-high',
  SteeringWheel = 'steering-wheel',
  Train = 'train',
  TouchPit = 'touch-pit',
  TruckDelivery = 'truck-delivery',
  Up = 'up',
  Upload = 'upload',
  Warehouse = 'warehouse',
  WoodenPalletPackedFull = 'wooden-pallet-packed-full',
}
